'use client';

import type { ComponentType } from 'react';
import type { SectionBlock, PageBlock } from '@impact/types';
import type { EditableWrapper } from '../types';
import { BlockRenderer } from '../BlockRenderer';
import { paddingToClass, contentWidthToClass } from './utils';

interface Props {
  block: SectionBlock;
  editing?: boolean;
  Wrapper?: EditableWrapper;
}

export function SectionGradientMesh({ block, editing, Wrapper }: Props) {
  const colors = block.data.meshColors ?? ['#7c3aed', '#06b6d4', '#f59e0b'];
  const gradient = `radial-gradient(at 0% 0%, ${colors[0]} 0%, transparent 50%), radial-gradient(at 100% 0%, ${colors[1]} 0%, transparent 50%), radial-gradient(at 50% 100%, ${colors[2]} 0%, transparent 50%)`;
  const textColorClass =
    block.data.textColor === 'light'
      ? 'text-white [&_*]:text-white [&_.text-muted-foreground]:text-white/70'
      : '';
  const paddingClass = paddingToClass(block.data.padding);

  return (
    <section
      className={`relative overflow-hidden ${paddingClass} ${textColorClass}`}
      style={{ background: gradient, backgroundColor: '#0f172a' }}
    >
      <div className={`relative z-10 mx-auto px-4 ${contentWidthToClass(block.data.contentWidth)}`}>
        {block.data.blocks.map((child: PageBlock) => (
          <BlockRenderer key={child.id} block={child} editing={editing} Wrapper={Wrapper} />
        ))}
      </div>
    </section>
  );
}
